import React, { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import Collapse from '@material-ui/core/Collapse'

class BkFlowEnhancementsAccordion extends Component {

	constructor(props) {
		super(props)
		this.state = {
			enhancementsExpanded: this.props.enhancementsExpanded
		}
	}

	handleEnhancementsAccordion() {
		this.setState({
			enhancementsExpanded: !this.state.enhancementsExpanded
		})
	}

	render() {
		const { enhancementsExpanded } = this.state
		const {
			configData,
			accordionEnhancementCards
		} = this.props
		const hotelLabels = configData.hotel.labels[0]

		return (
			<Fragment>
				<Collapse
					className="bk-flow-enhancements__group-accordion"
					in={ enhancementsExpanded }
					timeout={ 300 }
				>
					<div className="row center-xs">
						{ accordionEnhancementCards }
					</div>
				</Collapse>

				<button
					className="bk-flow-enhancements__toggle-accordion btn btn-xl btn-transparent"
					onClick={ () => this.handleEnhancementsAccordion() }
				>
					{ enhancementsExpanded  ?
						<Fragment>
							<span>{ hotelLabels.viewLessServices } -</span>
						</Fragment>
					:
						<Fragment>
							<span>{ hotelLabels.viewMoreServices } +</span>
						</Fragment>
					}
				</button>
			</Fragment>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration
	}
}

export default connect(mapStateToProps, null)(BkFlowEnhancementsAccordion)


// WEBPACK FOOTER //
// ./src/components/enhancements/BkFlowEnhancementsAccordion.js